<template>
  <v-layout class="auth-wrapper">
    <v-container fluid>
      <v-row class="fill-height" align="center" justify="center">
        <v-col class="py-6" cols="12" sm="8" md="6" lg="4" xl="3">
          <div class="d-flex align-center justify-center mb-6">
            <v-img
              :src="$settings?.profile?.logo"
              max-width="3rem"
              class="mr-4"
              contain
            />

            <span class="text-h5 font-weight-bold"> Gainmes </span>
          </div>

          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style lang="scss" src="./style.scss" scoped />
